import styled from 'styled-components';
import { ChevronDown } from 'icons/ChevronDown';

export const SelectWrapper = styled.div`
  &&& {
    display: flex;
    flex-direction: column;

    & [class$='-select-selection-search'] {
      overflow: hidden;
    }

    & [class$='-select-selector'] {
      background-color: var(--v3-black-1);
      border: 1px solid var(--v3-black-1);

      & [class$='-select-selection-item'] {
        padding-right: 26px;
      }

      & [class$='-select-selection-overflow'] {
        gap: 3px;

        & [class$='-select-selection-overflow-item'] {
          line-height: 32px;
          height: 38px;
          font-size: 14px;
          display: inline-flex;
          align-items: center;
          margin: 0;
        }
      }
    }
    & [class*='-select-dropdown'] {
      background-color: var(--v3-black-0);
      border: 1px solid var(--v3-black-2);
      box-shadow: 0px 16px 33px rgba(119, 110, 171, 0.11);
      border-radius: 12px;
      padding: 8px;
      margin-top: 10px;
    }
    & .rc-virtual-list-holder {
      overflow-y: auto !important;
    }
    & .ant-select-item {
      border-radius: 12px;
      padding: 12px 0;
      font-weight: 500;
      font-size: 15px;
      line-height: 25px;
      color: var(--v3-text-color);
    }
    & .ant-select-item-option {
      text-align: left;
      padding-left: 20px;
    }
    & .ant-select-item-group {
      text-align: left;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      letter-spacing: -0.02em;
      padding-left: 10px;
      color: var(--v3-black-45);
    }
    & .ant-select-item:hover {
      background-color: var(--v3-black-0);
    }
    & [class*='-select-focused'] {
      & [class$='-select-selector'] {
        background-color: var(--v3-black-1);
        border: 1px solid var(--v3-black-1);
        box-shadow: none;
      }
    }

    & .ant-select-open {
      & .ant-select-arrow {
        transform: rotate(180deg);
      }
    }

    & .ant-select-arrow {
      transition: transform 0.2s ease-in-out;
    }
  }
`;

export const SelectLabel = styled.div`
  font-weight: bold;
  font-size: 14px;
  color: var(--v3-black-85);
  line-height: 20px;
  letter-spacing: 0.3px;
  margin-bottom: 4px;
`;

export const SelectArrow = styled(ChevronDown)`
  color: var(--v3-text-color);
`;
